<template>
    <div class="form-group">
        <div class="row p-0">
            <div class="col-6 p-0">
                <label class="label">Total Weight - lbs.</label>
                <app-input 
                type="text"
                v-model="displayValueTotal"
                :placeholder="'Value'"
                :required="true"
                @input="updateValue"
                :disabled="true"
                />
            </div>
            <div class="col-6 p-0">
                <label class="label">Total Weight - per Container.</label>
                <app-input 
                    type="text"
                    v-model="displayValue"
                    :placeholder="'Value'"
                    :required="true"
                    :disabled="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PayloadLbs',
    props: {
        value: {
            type: Object,
            default: () => ({
                data: '',
                dataTotal : '',
            })
        },
        is_view : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            internalValue: { ...this.value }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        }
    },
    computed: {
        displayValue: {
            get() {
                const val = this.value.data;
                if (val === null || val === undefined || val === '') return '';
                
                // Usamos Intl para formatear con comas en miles y millones
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0 // Ajusta según necesites decimales
                }).format(val);
            },
            set(newValue) {
                // Quitamos todo lo que no sea número o punto para el "data" puro
                const cleanValue = newValue.replace(/[^\d.]/g, '');
                
                // Emitimos al padre
                this.$emit('input', { ...this.value, data: cleanValue });
            }
        },
        displayValueTotal: {
            get() {
                const val = this.value.dataTotal;
                if (val === null || val === undefined || val === '') return '';
                
                // Usamos Intl para formatear con comas en miles y millones
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0 // Ajusta según necesites decimales
                }).format(val);
            },
            set(newValue) {
                // Quitamos todo lo que no sea número o punto para el "data" puro
                const cleanValue = newValue.replace(/[^\d.]/g, '');
                
                // Emitimos al padre
                this.$emit('input', { ...this.value, dataTotal: cleanValue });
            }
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>